import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { __ } from "services/Translator";
import api from "services/api";

export default function PromotionSlider(props) {
  // BONUS
  const prevBonus = () => {
    promotionsRef.current.slickPrev();
  };
  const nextBonus = () => {
    promotionsRef.current.slickNext();
  };

  const promotionsSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: false,
    customPaging: function (i) {
      return (
        <a className={props.landingType}>
          <div className="round">
            <i class="fas fa-circle"></i>
          </div>
          <div className="line"></div>
        </a>
      );
    },
    dotsClass: "slick-dots deposit_slider_dots",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const promotionsRef = useRef();

  //Get Promotion functionality
  const [promotions, setPromotions] = useState([]);
  const getPromotions = async (page) => {
    props.setSpinner(true);
    var response = await api.get("/promotions", {
      promotion_type: "Deposit",
    });
    props.setSpinner(false);
    if (response.status === 200) {
      setPromotions(response.data.promotions);
    }
  };

  useEffect(() => {
    getPromotions();
  }, []);

  return (
    <section className="game_section">
      <div className="container-xxl">
        {/* <div className="section_title margin_top_30">{__("Our Selection")}</div>
        <div className="paragraph text-center">
          {__(
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod"
          )}
        </div>
        <div className="paragraph text-center margin_bottom_30">
          {__("tempor, Lorem ipsum dolor .")}
        </div> */}

        <div className="section_headline">
          <div className="headline_text"></div>
          <div className="headline_action">
            <button onClick={prevBonus} className="action_btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="20"
                fill="white"
                class="bi bi-arrow-left"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                />
              </svg>
              {__("Prev")}
            </button>
            <button onClick={nextBonus} className="action_btn">
              {__("Next")}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="20"
                fill="white"
                class="bi bi-arrow-right"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="deposit_promotion_slider deposit_slider margin_top_15  ">
          {promotions.length > 0 && (
            <Slider ref={promotionsRef} {...promotionsSettings}>
              {promotions.map((item, index) => (
                <div className="slick_item">
                  <div className="single_deposit">
                    <div className="deposit_img">
                      <img alt="game image" src={item.image} />
                    </div>
                    <div className="deposit_text">
                      <div className="badge"> {__("Popular")} </div>
                      <div className="title italic margin_top_30">
                        {__("GET YOUR WELCOME PACKAGE")}
                      </div>
                      <div className="title headline padding_bottom_0">
                        {item.title}
                      </div>
                      {/* <div className="title headline padding_top_0 margin_bottom_20">
                        {__("of your Deposit.")}
                      </div> */}

                      <Link
                        className={
                          "gameplay_btn margin_bottom_15 " + props.landingType
                        }
                        to="games/slots"
                      >
                        {__("Play Now")}
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          )}

          {/* <div className="slick_item d-none">
            <div className="single_deposit">
              <div className="deposit_img">
                <img
                  alt="game image"
                  src="https://chimpbytes.imgix.net/bonus-single-home-2.png?&dpr=1&format=auto&auto=format&w=618&h=311&max-age=2629056"
                />
              </div>
              <div className="deposit_text">
                <div className="badge"> {__("Popular")} </div>
                <div className="title italic margin_top_30">
                  {__("GET YOUR WELCOME PACKAGE")}
                </div>
                <div className="title headline padding_bottom_0">
                  {__("100% Monthly Bonus")}
                </div>
                <div className="title headline padding_top_0 margin_bottom_20">
                  {__("of your Deposit.")}
                </div>

                <Link
                  className={
                    "gameplay_btn margin_bottom_15 " + props.landingType
                  }
                  to="games/slots"
                >
                  {__("Play Now")}
                </Link>
              </div>
            </div>
          </div>
          <div className="slick_item d-none">
            <div className="single_deposit">
              <div className="deposit_img">
                <img
                  alt="game image"
                  src="https://chimpbytes.imgix.net/bonus-single-home-1.png?&dpr=1&format=auto&auto=format&w=618&h=311&max-age=2629056"
                />
              </div>
              <div className="deposit_text">
                <div className="badge"> {__("Popular")} </div>
                <div className="title italic margin_top_30">
                  {__("GET YOUR WELCOME PACKAGE")}
                </div>
                <div className="title headline padding_bottom_0">
                  {__("100% Monthly Bonus")}
                </div>
                <div className="title headline padding_top_0 margin_bottom_30">
                  {__("of your Deposit.")}
                </div>

                <Link
                  className={
                    "gameplay_btn margin_bottom_15 " + props.landingType
                  }
                  to="games/slots"
                >
                  {__("Play Now")}
                </Link>
              </div>
            </div>
          </div>
          <div className="slick_item d-none">
            <div className="single_deposit">
              <div className="deposit_img">
                <img
                  alt="game image"
                  src="https://chimpbytes.imgix.net/bonus-single-home-2.png?&dpr=1&format=auto&auto=format&w=618&h=311&max-age=2629056"
                />
              </div>
              <div className="deposit_text">
                <div className="badge"> {__("Popular")} </div>
                <div className="title italic margin_top_30">
                  {__("GET YOUR WELCOME PACKAGE")}
                </div>
                <div className="title headline padding_bottom_0">
                  {__("100% Monthly Bonus")}
                </div>
                <div className="title headline padding_top_0 margin_bottom_30">
                  {__("of your Deposit.")}
                </div>

                <Link
                  className={
                    "gameplay_btn margin_bottom_15 " + props.landingType
                  }
                  to="games/slots"
                >
                  {__("Play Now")}
                </Link>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
